import { render, staticRenderFns } from "./ResultK.vue?vue&type=template&id=05f8f29c&"
import script from "./ResultK.vue?vue&type=script&lang=js&"
export * from "./ResultK.vue?vue&type=script&lang=js&"
import style0 from "./ResultK.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports